import { Order } from 'utils/types';

// generate types based on the given keys

type FormattedValue = {
  raw: string;
  formatted: string;
  number: number;
};

export const getFormattedSummary = (
  order: Order,
): {
  total: FormattedValue;
  discount: FormattedValue;
  shipping: FormattedValue;
  subtotal: FormattedValue;
} => ({
  total: formatValue(order.total),
  discount: formatValue(order.promo_total),
  shipping: formatValue(order.shipping),
  subtotal: formatValue(order.amount),
});

const formatValue = (value?: string, defaultValue = '0.00'): FormattedValue => {
  const cleanValue = value ?? defaultValue;

  return {
    raw: cleanValue,
    formatted: cleanValue.startsWith('-')
      ? `-$${cleanValue.replace('-', '')}`
      : `$${cleanValue}`,
    number: parseFloat(cleanValue),
  };
};
